import {
    ACTION_TYPES,
    LOCATION_TYPES,
    MAPBOX_SELECTED_LOCATION_ZOOM,
    MARKER_LAYERS,
    PAM_SELECTED_LOCATION_ZOOM,
} from 'Utils/constants';
import * as mapManager from 'Utils/explorer/mapManager';
import createDestinationMarker from 'Utils/explorer/createDestinationMarker';
import {getFeaturesInGroup} from 'Utils/routeManager';

const setSearchLocation = ({
    feature: searchFeature,
    zoomToResult = true,
    fitBounds = false,
    bearing = 0,
}) => (dispatch, getState) => {
    const feature = searchFeature?.feature
        ? {...searchFeature, ...searchFeature?.feature}
        : searchFeature;

    mapManager.removeMarkers(MARKER_LAYERS.SEARCH_LOCATIONS);

    const state = getState();
    const prevSearchLocation = state.pageState.explorerMap.searchLocation;

    // If there's a prevSearchLocation, deselect it
    if (prevSearchLocation && prevSearchLocation.properties.locationType === LOCATION_TYPES.PAM) {
        mapManager.setFeatureState({
            feature: prevSearchLocation,
            selected: false,
        });
    }

    if (feature) {
        mapManager.setFeatureState({feature, selected: true, isStartLocation: false});

        let pointsToAdd;
        if (feature.properties?.routeViaGroupId) {
            const featuresInGroup = getFeaturesInGroup(feature.properties?.routeViaGroupId);
            pointsToAdd = featuresInGroup
                ? featuresInGroup.map(
                      featureInGroup => featureInGroup.properties.displayPoint || featureInGroup
                  )
                : [];
        } else {
            pointsToAdd = [feature?.properties?.displayPoint || feature];
        }

        mapManager.addPointsToMap({
            points: pointsToAdd,
            maxZoom: 18.5,
            markerLayer: MARKER_LAYERS.SEARCH_LOCATIONS,
            zoomToResult,
            customMarker: createDestinationMarker({showLabel: true}),
        });
    }

    if (fitBounds) {
        const maxZoom =
            feature.properties.locationType === LOCATION_TYPES.PAM
                ? PAM_SELECTED_LOCATION_ZOOM
                : MAPBOX_SELECTED_LOCATION_ZOOM;
        mapManager.fitToGeoJson(
            feature,
            {topPadding: 0, bottomPadding: 0, maxZoom, substituteRouteViaGroupFeatures: true},
            {bearing}
        );
    }

    dispatch({
        type: ACTION_TYPES.SET_SEARCH_LOCATION,
        data: feature,
    });
};

export default setSearchLocation;
